module.exports = __webpack_public_path__ + "static/media/BAck@2x.46decb84.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/BAck@2x.png
// module id = 61
// module chunks = 0